/**
 * The distance from the bottom of the scrollable area to the bottom of the container.
 * This will roughly allow that when we scroll almost to the last element,
 * we hide this button so we don't cover the last element anymore.
 */
const SCROLL_OFFSET_BOUNDARY = 40; // px

export const calculateOffset = (scrollHeight: number, scrollTop: number, clientHeight: number) => {
    return Math.abs(scrollHeight - scrollTop - clientHeight);
};

export interface IJumpToBottom {
    setVisibility: () => void;
    setContainer?: (container: Element) => void;
}

export class JumpToBottom implements IJumpToBottom {
    private container: Element;
    isVisible = false;

    setContainer(container: Element) {
        this.container = container;
    }

    onClick() {
        this.container.scrollTo({ top: this.container.scrollHeight, behavior: 'smooth' });
    }

    shouldBeVisible() {
        const currentOffset = calculateOffset(
            this.container.scrollHeight,
            this.container.scrollTop,
            this.container.clientHeight
        );

        // If the user hasn't fully scrolled down yet, then jump to bottom button is displayable.
        return currentOffset > SCROLL_OFFSET_BOUNDARY;
    }

    setVisibility() {
        /*
            We're using requestAnimationFrame here because Alpine's $nextTick
            only waits for the DOM mutation queue to finish (not for the browser to
            repaint or reflow the layout)
            When using x-if or x-show, elements may not be fully inserted/measurable
            by the time $nextTick resolves, especially when calculating scrollHeight,
            offsetHeight, etc.
            requestAnimationFrame defers execution until the browser is about to repaint,
            ensuring all layout and style calculations are complete.
        */
        requestAnimationFrame(() => {
            this.isVisible = this.shouldBeVisible();
        });
    }
}
